import { apiClient } from './client';

export async function getNotifications(params = {}) {
  const { data } = await apiClient.get('/api/auth/notifications', { params });
  return data;
}

export async function getUnreadNotificationCount() {
  const { data } = await apiClient.get('/api/auth/notifications/unread-count');
  return data.data?.count ?? 0;
}

export async function markNotificationRead(id) {
  const { data } = await apiClient.patch(`/api/auth/notifications/${id}/read`);
  return data.data;
}

export async function markNotificationUnread(id) {
  const { data } = await apiClient.patch(`/api/auth/notifications/${id}/unread`);
  return data.data;
}

export async function dismissNotification(id) {
  const { data } = await apiClient.patch(`/api/auth/notifications/${id}/dismiss`);
  return data.data;
}

export async function markAllNotificationsRead() {
  const { data } = await apiClient.post('/api/auth/notifications/mark-all-read');
  return data.data;
}

export async function getNotificationPreferences() {
  const { data } = await apiClient.get('/api/auth/notification-preferences');
  return data.data || [];
}

export async function updateNotificationPreferences(payload) {
  const { data } = await apiClient.put('/api/auth/notification-preferences', payload);
  return data.data || [];
}

export async function getNotificationTemplates(params = {}) {
  const { data } = await apiClient.get('/api/system/notification-templates', { params });
  return data;
}

export async function createNotificationTemplate(payload) {
  const { data } = await apiClient.post('/api/system/notification-templates', payload);
  return data.data;
}

export async function updateNotificationTemplate(id, payload) {
  const { data } = await apiClient.put(`/api/system/notification-templates/${id}`, payload);
  return data.data;
}

export async function activateNotificationTemplate(id) {
  const { data } = await apiClient.patch(`/api/system/notification-templates/${id}/activate`);
  return data.data;
}

export async function deactivateNotificationTemplate(id) {
  const { data } = await apiClient.patch(`/api/system/notification-templates/${id}/deactivate`);
  return data.data;
}
